<template>
  <p class="modal__message" v-if="message" v-html="message" />
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * 共通 モーダルメッセージ テンプレート
 */
export default defineComponent({
  name: 'ModalMessageParts',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
})
</script>

<style lang="scss" scoped>
.modal__message {
  width: 100%;
  text-align: center;
  @include fontSetTextMedium();

  letter-spacing: 0.04em;
  margin-top: 16px;

  &:first-child {
    margin-top: 36px;
  }

  ::v-deep a {
    text-decoration: underline;
  }
}
</style>
